import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ScrollControlService } from 'src/app/modules/shared/services/scroll-control.service';
import { SidenavService } from 'src/app/modules/shared/services/sidenav.service';

@Component({
  standalone: false,
  selector: 'app-estimativa',
  templateUrl: './estimativa.component.html',
  styleUrls: ['./estimativa.component.css']
})
export class EstimativaComponent implements OnInit, OnDestroy {

  variables: any;

  isOpen: boolean = false;
  userName: any;
  // isAdmin: boolean = false;
  shouldPinSidenav: boolean = false;

  // Phase management: 1 = Estimativa form, 2 = Sub Tarefas (Activities)
  currentPhase: number = 1;
  estimate: any = null;
  estimateName: string = '';
  subTasks: any = [];
  technology: any = null;
  originalProject: any = null;
  isUpdate: boolean = false;
  idEstimate: string = '';
  estimativaNavigationContext: any = null;
  aiActionItems: any[] = [];
  modifiedSubTasks: any[] = [];
  subTasksAiWarning: boolean = false;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  constructor(
    private sidenavService: SidenavService,
    public authService: AuthService,
    private router: Router,
    private dataService: DataService,
    private languageService: LanguageService,
    private scrollService: ScrollControlService) { }

  ngOnDestroy(): void {
    console.log('Estimator Component is being destroyed');
    this.dataService.clearAiGeneratedMacros();
    this.dataService.clearAiGeneratedActionItems();
    this.dataService.clearShowAiMacroWarning();

  }

  ngOnInit() {
    this.scrollService.setScroll(false);


    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    //   this.userName = sessionStorage.getItem("username");
    //   this.isAdmin = sessionStorage.getItem("role")  === "admin" ? true : false;

    console.log(this.estimateName);
    console.log(this.isUpdate);

  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  handleScroll(targetElement: HTMLElement): void {
    const container = this.scrollContainer.nativeElement as HTMLElement;
    const containerRect = container.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();

    // Calculate the target's offset relative to the container's top:
    const offset = targetRect.top - containerRect.top + container.scrollTop - 180;

    container.scrollTo({ top: offset, behavior: 'smooth' });
  }

  // Handle transition from phase 1 (Estimativa) to phase 2 (Sub Tarefas)
  goToActivities(data: any): void {
    this.estimate = data.estimate;
    this.technology = data.technology;
    this.originalProject = data.originalProject;
    this.isUpdate = data.isUpdate;
    this.idEstimate = data.idEstimate;
    this.subTasks = data.estimate.subTasks || [];
    this.modifiedSubTasks = data.modifiedSubTasks || [];
    this.subTasksAiWarning = data.subTasksAiWarning;
    this.currentPhase = 2;
  }

  // Handle transition from phase 2 back to phase 1
  backToEstimativa(estimate: any): void {
    this.estimate = estimate;
    this.currentPhase = 1;
    //show unselected aiGenerated macros
  }

  // Update subtasks when coming back from phase 2
  updateSubTasks(subTasks: any): void {
    this.subTasks = subTasks;
  }

  // Handle estimate name changes from custom stepper
  onEstimateNameChange(name: string): void {
    this.estimateName = name;
  }

  // Handle isUpdate state changes from custom stepper
  onIsUpdateChange(isUpdate: boolean): void {
    this.isUpdate = isUpdate;
  }


  goToDashboard() {
    const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
    this.dataService.clearEstimativaNavigationContext();
    if (source?.origin === 'combinedResultPage' || source?.origin === 'projectPage') {
      this.router.navigate(['/projecto']);
    } else if (source?.origin === 'resultPage') {
      this.router.navigate(['/estimativa/resultado']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

}
